// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Belt_Float from "rescript/lib/es6/belt_Float.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";

function px(x) {
  return String(x) + "px";
}

function stripPx(x) {
  return Belt_Option.getExn(Belt_Float.fromString(x.replace("px", "")));
}

var animationFunction = "cubic-bezier(0.2, 0, 0, 1)";

function transition(prop) {
  return prop + (" " + (String(200) + "ms cubic-bezier(0.2, 0, 0, 1)"));
}

function translate(x, y) {
  return "translate(" + (String(x) + "px, " + (String(y) + "px)"));
}

function getComputedStyle(element) {
  return window.getComputedStyle(element);
}

var Web;

var animationDuration = 200;

var resetAnimationsFactor = -70;

var finishDropFactor = 20;

export {
  Web ,
  px ,
  stripPx ,
  animationFunction ,
  animationDuration ,
  resetAnimationsFactor ,
  finishDropFactor ,
  transition ,
  translate ,
  getComputedStyle ,
  
}
/* No side effect */
